export default {
  methods: {
    locationVerificationCheck(status) {
      const storedUserDetails = localStorage.getItem("user");
      const userDetails = JSON.parse(storedUserDetails);
      if (userDetails.app_user.status !== status) {
        return true;
      } else {
        return false;
      }
    },
    questionaireCheck(status) {
      const storedUserDetails = localStorage.getItem("user");
      const userDetails = JSON.parse(storedUserDetails);
      if (userDetails.app_user.status !== status) {
        return false;
      } else {
        return true;
      }
    },
    async notification(header, body, url) {
      if ("Notification" in window && Notification.permission === "granted") {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration) {
          registration.showNotification("✅ Check-in Successful", {
            body: "You're now checked in!",
            icon: "/icons/icon-192x192.png",
            badge: "/icons/badge.png",
            vibrate: [200, 100, 200],
            data: { url: "/" },
          });
        }
      }
    },
  },
};
